import { QueryDispatcher } from "@/modules/shared/domain/QueryDispatcher";

export interface DownloadUploadedRepresentationPdfResult {
  url: string | null;
  error: string | null;
}

export interface DownloadUploadedRepresentationPdfQueryParams {
  user_id: number;
  company_id: number;
}

export class DownloadUploadedRepresentationPdfQuery {
  constructor(
    private readonly dispatcher: QueryDispatcher
  ) { }

  async run(params: DownloadUploadedRepresentationPdfQueryParams): Promise<DownloadUploadedRepresentationPdfResult> {
    const args = {
      user_id: params.user_id,
      company_id: params.company_id
    }

    const res = await this.dispatcher.dispatch('download.uploaded.representation.pdf', args);
    return res as DownloadUploadedRepresentationPdfResult;
  }
}
